(function(angular) {

    angular.module('app')
        .directive("validateDate",
            function() {
                // requires an isloated model
                return {
                    // restrict to an attribute type.
                    restrict: 'A',
                    // element must have ng-model attribute.
                    require: 'ngModel',
                    link: function(scope, ele, attrs, ctrl) {

                        // add a parser that will process each time the value is
                        // parsed into the model when the user updates it.
                        ctrl.$parsers.unshift(function (value) {
                            var valid;

                            if (value) {
                             
                                var month = value.slice(0, 2);
                                var day = value.slice(3, 5);
                                var year = value.slice(6);

                                 var valueValid;
                                 valueValid = month < 13 && month > 0;
                                 valueValid = valueValid && day > 0 && day < 32;
                                 
                                 ctrl.$setValidity('badDateValue', valueValid);

                                valid = birthDateValid;
                            }

                            // if it's valid, return the value to the model,
                            // otherwise return undefined.
                            return valid ? value : undefined;
                        });

                    }
                }
            });

})(angular);